export default __webpack_public_path__ + "static/media/progressSuccess.4b7dee11.svg";